import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=7118da4d&scoped=true"
import script from "./successPage.vue?vue&type=script&lang=js"
export * from "./successPage.vue?vue&type=script&lang=js"
import style0 from "./successPage.vue?vue&type=style&index=0&id=7118da4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7118da4d",
  null
  
)

export default component.exports